<template>
  <transition
    enter-active-class="transition duration-300 ease-out transform"
    enter-class="scale-95 opacity-0"
    enter-to-class="scale-100 opacity-100"
    leave-active-class="transition duration-150 ease-in transform"
    leave-class="scale-100 opacity-100"
    leave-to-class="scale-95 opacity-0"
  >
    <div
      v-if="openModal"
      class="
        flex
        items-center
        justify-center
        fixed
        left-0
        bottom-0
        w-full
        h-full
        z-50
      "
      style="background-color: #00000099"
    >
      <slot />
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ModalLayout',
  props: ['openModal'],
};
</script>
